// extracted by mini-css-extract-plugin
export default {"AuthPageContent":"AuthPage_AuthPageContent__RRXcZ","ContentWrapper":"AuthPage_ContentWrapper__3S4fw"};